var _defs, _rect, _rect2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInnerBg10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 555.75 315.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#91181d;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 278.91,
    y1: 382.22,
    x2: 278.91,
    y2: 107.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4e795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#f4b331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#f4ad31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#f48631"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#f46e31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f46531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 278.09,
    y1: 323.76,
    x2: 278.09,
    y2: 53.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f46531"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f46e31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f48631"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#f4ad31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#f4b331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#f4b331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4e795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 279.42,
    y1: 323.76,
    x2: 279.42,
    y2: 53.27,
    xlinkHref: "#linear-gradient-2"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 8.63,
    y: 11.55,
    width: 539.9,
    height: 297.44,
    rx: 48.24
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 14.34,
    y: 18.96,
    width: 529.15,
    height: 283.61,
    rx: 48.24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M530.39,47.82V275.93c0,11.88-12.79,21.5-28.56,21.5H54.35c-15.77,0-28.55-9.62-28.55-21.5V47.82c0-11.87,12.78-21.5,28.55-21.5H501.83C517.6,26.32,530.39,36,530.39,47.82Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M539.23,47.82V275.93c0,11.88-13.17,21.5-29.41,21.5H49c-16.24,0-29.4-9.62-29.4-21.5V47.82c0-11.87,13.16-21.5,29.4-21.5h460.8C526.06,26.32,539.23,36,539.23,47.82Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnerBg10);
export default __webpack_public_path__ + "static/media/Inner BG-10.465c48a2fa1714b18c03b930488e6cf9.svg";
export { ForwardRef as ReactComponent };